export default __webpack_public_path__ + "images/WinterPtoApprovalsBackground.web.png";